import Vue from 'vue';
import vueStars from 'vue-stars/src/plugin';

Vue.use(vueStars);
